import { render, staticRenderFns } from "./student-tag.vue?vue&type=template&id=609f60a4&scoped=true"
import script from "./student-tag.vue?vue&type=script&lang=js"
export * from "./student-tag.vue?vue&type=script&lang=js"
import style0 from "./student-tag.vue?vue&type=style&index=0&id=609f60a4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609f60a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('609f60a4')) {
      api.createRecord('609f60a4', component.options)
    } else {
      api.reload('609f60a4', component.options)
    }
    module.hot.accept("./student-tag.vue?vue&type=template&id=609f60a4&scoped=true", function () {
      api.rerender('609f60a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/research/student-tag.vue"
export default component.exports